import { connect } from "react-redux";
import * as React from "react";

import { FullFormState } from "../../../../../../Engine/Core/Store/FullFormState";
import { withViewModelSelect } from "../../../../../withViewModelSelect";
import { ViewModelSelect } from "../../../../../../Helpers/StateAccessors/ViewModelSelect";
import { isUnitIdEquals, UnitId, unitIdWithInstance } from "../../../../Unit/UnitId/UnitId";
import { AbsoluteResolvedModelPath } from "../../../../../../../../Common/ModelPath/ModelPath";
import { UnitLabelPath } from "../../../../../../../../Common/PathConstants";
import { getLabel } from "../../../UnitItemHelpers";

import { MenuItemChildInstance } from "./MenuItemChildInstance";

export interface MenuItemChildInstanceContainerProps {
    id: UnitId;
    unitPath: AbsoluteResolvedModelPath;
    instance: string;
    instanceIndex: number;
    viewModelSelect: ViewModelSelect;
    getInstanceTitle: (instance: string, instanceIndex: number) => string;
    getInstanceExtraInfo: (instance: string) => string | undefined;
    children?: React.ReactNode;
    isChildItemActive?: boolean;
    index: number;
}

const mapStateToProps = (state: FullFormState, props: MenuItemChildInstanceContainerProps) => {
    const highlightUnitInstancesStack = state.highlightUnit?.instancesStack ?? [];
    const instanceTitle = props.getInstanceTitle(props.instance, props.instanceIndex);
    const extraInfo = props.getInstanceExtraInfo(props.instance);
    const isCurrentInstanceHasActiveChild =
        props.instance ===
        highlightUnitInstancesStack.find(it => it.bindingPath.toLegacyPath() === props.unitPath.toLegacyPath())
            ?.instance;

    const instancePath = props.unitPath.joinWith(props.instance);
    const errorsCount = Number(props.viewModelSelect.customFieldValue(state, instancePath, "errorsCount", ""));
    return {
        instanceTitle: instanceTitle,
        isCurrent: isUnitIdEquals(state.highlightUnit, unitIdWithInstance(props.id, props.instance)),
        isReadOnly: state.settings.isReadOnly,
        hasSingleChild: !props.children,
        isChildItemActive:
            props.id.pageId !== state.highlightUnit?.pageId &&
            props.isChildItemActive &&
            isCurrentInstanceHasActiveChild,
        label: getLabel(
            props.viewModelSelect.customFieldValue(
                state,
                props.unitPath.joinWith(props.instance).joinWith(UnitLabelPath),
                "value"
            )
        ),
        index: props.index,
        extraInfo: extraInfo,
        errorsCount: errorsCount,
    };
};

export const MenuItemChildInstanceContainer = withViewModelSelect(connect(mapStateToProps)(MenuItemChildInstance));
